export default "__VITE_ASSET__CZgfnW51__"